/**
 * Multi-agent pipeline constants.
 *
 * The five phases of every multi-agent run (Intake → Synthesis)
 * and their per-state display labels.  Extracted from PipelineStepper
 * so any future component showing phase progress reads from the
 * same ordered list.
 */

export const PIPELINE_PHASES = [
  "Intake",
  "Planner",
  "Tools",
  "Workers",
  "Synthesis",
] as const;

export type PipelinePhase = (typeof PIPELINE_PHASES)[number];

export type PhaseStatus = "done" | "active" | "queued" | "failed";

export const PHASE_SUBLABEL: Record<PhaseStatus, string> = {
  done:    "Completed",
  active:  "In progress",
  queued:  "Queued",
  failed:  "Failed",
};
